export Form from './Form';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/components/index.js